import { useState } from "react";
import { User } from "features/user/types";

export function useDueInvoicesState(user: User | null) {
  const [isDismissed, setIsDismissed] = useState(() => {
    return sessionStorage.getItem("dueInvoicesBannerDismissed") === "true";
  });

  const dismissBanner = () => {
    sessionStorage.setItem("dueInvoicesBannerDismissed", "true");
    setIsDismissed(true);
  };

  if (!user) {
    return {
      shouldShowBanner: false,
      isDismissed: true,
      dismissBanner: () => {},
      dueInvoicesCount: 0,
      totalDues: undefined,
      dueSince: undefined,
      currencyCode: undefined,
      isAdmin: false,
      adminEmail: undefined,
    };
  }

  const dueInvoicesCount =
    user.subscription?.subscription?.due_invoices_count || 0;
  const totalDues = user.subscription?.subscription?.total_dues;
  const dueSince = user.subscription?.subscription?.due_since;
  const currencyCode = user.subscription?.subscription?.currency_code;
  const isAdmin = user.role === "admin";
  const adminEmail = user.adminEmail;

  const shouldShowBanner = dueInvoicesCount > 0;

  return {
    shouldShowBanner,
    isDismissed,
    dismissBanner,
    dueInvoicesCount,
    totalDues,
    dueSince,
    currencyCode,
    isAdmin,
    adminEmail,
  };
}
